import { Product } from 'shared/interfaces/Product';

export interface Subscription {
  organisation: string;
  user: string;
  product: Product;
  startDate: number;
  renewDate: number;
  subscriptionDuration: number;
  stripeCustomerId: string;
  stripeSubscriptionId: string;
  cancelAtRenewDate?: boolean;
  downgradeToProductAtRenewDate?: Product;
  hasUsedChurnRetentionDiscount?: boolean;
  promoCode: PromoCode;
  trialDetails?: TrialDetails;
}

export interface SubscriptionBalance {
  amount: number;
}

export enum CancelationReason {
  NULL = '',
  TOO_EXPENSIVE = 'too_expensive',
  MISSING_FEATURES = 'missing_features',
  SWITCHED_SERVICE = 'switched_service',
  CUSTOMER_SERVICE = 'customer_service',
  TOO_COMPLEX = 'too_complex',
  UNUSED = 'unused',
  LOW_QUALITY = 'low_quality',
  OTHER = 'other'
}

export class ChurnDataDto {
  reason?: CancelationReason;
  comment?: string;
}

export interface ChurnDiscount {
  numberOfMonths: number;
  discountPercentage: number;
}

export interface PromoCode {
  stripeId: string;
  stripeCouponId: string;
  numberOfMonths: number;
  discountPercentage: number;
}

export interface TrialDetails {
  startDate: number;
  endDate: number;
}
